import React from "react";
import styles from "./Header.module.css";

function Header({ children }) {
    return (
        <div className={styles.header}>
            <h3>{children}</h3>
        </div>
    );
}

export default Header;
